<template>
  <div>
    <basicHeader
      :title="$t('setup.label.CreateChargeCode')"
      @backPress="$router.push(`/setup/charge-code`)"
    />
    <ValidationObserver ref="observer">
      <vx-card class="form-padding">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full" style="height: 70px">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.ChargeCode')"
            >
              <vs-input
                :label="$t('setup.label.ChargeCode')"
                v-model="chargeCode.chargeCode"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.ChargeDescription')"
            >
              <vs-input
                :label="$t('setup.label.ChargeDescription')"
                v-model="chargeCode.chargeDescription"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.ChargeType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ChargeType')"
              >
                <v-select
                  label="chargeType"
                  :reduce="(obj) => obj.chargeType"
                  :options="formTemplate.chargeTypeData"
                  v-model="chargeCode.chargeType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.chargeType
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider
              rules="required|numeric"
              v-slot="{ errors }"
              :name="$t('setup.label.ChargeDuration')"
            >
              <vs-input
                :label="$t('setup.label.ChargeDuration')"
                v-model="chargeCode.chargeDuration"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.DurationType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.DurationType')"
              >
                <v-select
                  label="durationTypeCode"
                  :reduce="(mCodeValue) => mCodeValue.durationTypeCode"
                  :placeholder="$t('setup.label.SelectSearch')"
                  :options="formTemplate.durationTypeData"
                  v-model="chargeCode.durationType"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.durationTypeCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.TaxCode") }}
                <span class="required"> *</span>
              </small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.TaxCode')"
              >
                <v-select
                  label="taxCode"
                  :reduce="(mCodeValue) => mCodeValue.taxCode"
                  :placeholder="$t('setup.label.SelectSearch')"
                  :options="formTemplate.taxCodeData"
                  v-model="chargeCode.taxCode"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.taxCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.BillFrequencyCode")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BillFrequencyCode')"
              >
                <v-select
                  label="billFrequencyCode"
                  :options="formTemplate.billFrequencyCodeData"
                  :reduce="(mCodeValue) => mCodeValue.billFrequencyCode"
                  v-model="chargeCode.billFrequencyCode"
                  :placeholder="$t('setup.label.SelectSearch')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.billFrequencyCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div style="height: 10px"></div>
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="chargeCode.isAggregate"
                  >{{ $t("setup.label.IsAggregate") }}</vs-checkbox
                >
                <div style="height: 20px"></div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div style="height: 10px"></div>
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="chargeCode.taxInclusive"
                  >{{ $t("setup.label.TaxInclusive") }}</vs-checkbox
                >
                <div style="height: 20px"></div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="center">
        <span class="ml-3 mr-4">
          <vs-button
            type="border"
            style="width: 190px; margin-top: 20px; margin-bottom: 10px"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
        </span>
        <span class="ml-1 mr-2">
          <vs-button style="width: 190px" @click="handleCreateChargeCode">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </span>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import basicHeader from "@/components/common/basicHeader";
const chargeCodeEmpty = {
  taxInclusive: false,
  isAggregate: false,
  chargeCode: "",
  chargeType: "",
  durationType: "",
  billFrequencyCode: "",
  chargeDescription: "",
  chargeDuration: "",
  locale: "en",
  taxCode: "",
};

export default {
  data() {
    return {
      chargeCode: chargeCodeEmpty,
      warningPopup: false,
      descriptionItems: [5, 10, 15],
      errorMessage: "",
      errors: [],
      warningText: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    FormWizard,
    TabContent,
    "v-select": vSelect,
    basicHeader,
  },
  computed: {
    formTemplate() {
      return this.$store.getters["chargecode/getFormTemplate"];
    },
  },
  methods: {
    async handleCreateChargeCode() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.submitChargeCode();
    },
    async submitChargeCode() {
      try {
        await this.$store.dispatch(
          "chargecode/createChargeCodeAction",
          this.chargeCode
        );
        this.$router.push({ path: "/setup/charge-code" });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Charge Code Created Successfully!",
          type: "success",
        });
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async callChargeTemplate() {
      try {
        this.$store.dispatch("chargecode/setFormTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    resetForm() {
     this.chargeCode = {
        taxInclusive: false,
        isAggregate: false,
        chargeCode: "",
        chargeType: "",
        durationType: "",
        billFrequencyCode: "",
        chargeDescription: "",
        chargeDuration: "",
        locale: "en",
        taxCode: "",
      };

      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },
  },
  mounted() {
    this.resetForm();
    this.callChargeTemplate();
  },
};
</script>
<style>
.form-error-message {
  /* border: 0.2rem solid rgba(255, 77, 77, 0.455); */
  background-color: rgb(255, 255, 255);
  color: rgb(131, 0, 0);
  padding: 0.5rem;
  border-radius: 0.3rem;
  margin: 0.5rem 0.1rem;
  /* box-shadow: 0.1px 0.1px 0.3rem 0px rgba(255, 132, 132, 0.397); */
}

.chCodeLay {
  font-weight: 550;
  font-size: 16px;
  line-height: 120%;
  padding: 10px 0;
  letter-spacing: 0.005em;
  text-transform: uppercase;
  color: #333;
}
.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  width: 42%;
  left: 45px;
}
</style>
